{
  "Description": "PM : 97500",
  "RedundantCharacters": " -",
  "ValidationRegex": "^97500$",
  "TestData": {
    "Valid": [
      "97500"
    ],
    "Invalid": [
      "975000",
      "9750"
    ]
  }
}